import request from '@/utils/request'

// 用户登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 用户登出
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

// 刷新Token
export function refreshToken(refreshTokenValue) {
  return request({
    url: '/auth/refresh',
    method: 'post',
    data: { refreshToken: refreshTokenValue }
  })
}

// 验证Token
export function validateToken() {
  return request({
    url: '/auth/validate',
    method: 'get'
  })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: '/auth/user-info',
    method: 'get'
  })
}

// 获取图形验证码（后端返回 { uuid, image(base64 data URL) }）
export function getCaptcha() {
  return request({
    url: '/captcha',
    method: 'get'
  })
}

// 兼容旧版本API别名
export const getInfo = getUserInfo
export const getCodeImg = getCaptcha